/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {PersonnelLog} from '../models/personnelLog';

export class PersonnelLogStore extends EntityStore {
  personnelLogs = [];

  constructor(rootStore) {
    super(rootStore, 'personnelLogs', Api.personnelLogs, PersonnelLog);
  }

  getByWorkplaceId(workplaceId) {
    return this.personnelLogs.filter((log) => log.workplaceId === workplaceId);
  }

  getLatestByWorkplaceId(workplaceId) {
    const logs = this.getByWorkplaceId(workplaceId)
      .sort((a, b) => a.createdAt - b.createdAt);
    return logs.length > 0 ? logs[logs.length - 1] : null;
  }

  getNextByTimestamp(timestamp) {
    return this.personnelLogs.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
      .find((log) => log.createdAt > timestamp);
  }
}

decorate(PersonnelLogStore, {
  selected: observable,
  personnelLogs: observable,
});
